module.exports = __webpack_public_path__ + "static/media/W19-1581_2.50_Egger_767x845-mobile_fr.094de5f9.jpg";